import request from "../utils/request";

export async function PairPos(serialNumber) {
  return request.post("PavoCloud/pair/" + serialNumber);
}

export async function SendOrder(order) {
  return request.post("PavoCloud/send", order);
}

export async function GetCloudRequests() {
  return request.get("PavoCloud/requests");
}

export async function CancelCloudRequest(id) {
  return request.delete("PavoCloud/"+id);
}

export async function ConfirmCloudRequest(id,branchId) {
  return request.post("PavoCloud/success/"+id+"/"+branchId);
}
